export default {
    container: {
        borderWidth: 1,
        borderColor: "rgba(100,100,100,0.3)",
        borderRadius: 4
    }
};
